import {Controller} from "@hotwired/stimulus"

// Lets a report card switch its number scale (units / thousands / lakhs /
// millions / crores) in real time. Selecting an option writes
// `data-report-scale` onto the card element and pushes the new scale to every
// `currency` outlet inside this card. Each cell re-formats against the scale
// of the card it lives in, so cards switch independently. Virtualised
// SlickGrid rows that mount later read the scale on connect (via the ancestor
// attribute) and also receive a push via `currencyOutletConnected`.
export default class extends Controller {
  static targets = ["label", "option"]
  static outlets = ["currency"]

  select(event) {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return

    const button = event.currentTarget
    const scale  = button.dataset.scaleValue
    const label  = button.dataset.scaleLabel
    if (!scale) return
    event.preventDefault()

    this.element.setAttribute('data-report-scale', scale)

    if (this.hasLabelTarget && label) {
      this.labelTarget.textContent = label
    }

    this.markActive(scale)
    this.currencyOutlets.forEach((outlet) => outlet.applyScale(scale))
    if (this.element.querySelector('.lz-native-report-pagination')) this.updateNativeNavigation(scale)
    const menu = button.closest('details')
    if (menu) menu.open = false
  }

  updateNativeNavigation(scale) {
    // Native pages render again on navigation; carry this card's live scale forward.
    this.element.querySelectorAll('a[data-turbo-frame], a[data-turbo-stream]').forEach((link) => {
      if (link.hasAttribute('data-scale-value')) return
      const url = new URL(link.href, window.location.href)
      if (url.origin !== window.location.origin) return
      url.searchParams.set('number_scale', scale)
      link.href = url.toString()
    })
    this.element.querySelectorAll('form[method="get"]').forEach((form) => {
      let input = form.querySelector('input[name="number_scale"]')
      if (!input) {
        input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'number_scale'
        form.appendChild(input)
      }
      input.value = scale
    })
  }

  currencyOutletConnected(outlet) {
    const scale = this.element.getAttribute('data-report-scale')
    if (scale) outlet.applyScale(scale)
  }

  // Highlight the chosen scale in the dropdown list and clear the others, so
  // the menu always shows which scale the card is currently rendered at.
  markActive(scale) {
    this.optionTargets.forEach((option) => {
      const active = option.dataset.scaleValue === scale
      option.classList.toggle('bg-brand-soft', active)
      option.classList.toggle('text-brand', active)
      option.classList.toggle('font-semibold', active)
      option.classList.toggle('text-ink', !active)
      const check = option.querySelector('[data-scale-check]')
      if (check) check.classList.toggle('invisible', !active)
    })
  }
}
